export default "__VITE_ASSET__DbY$MOch__"